class DiscountCheckoutButton extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({mode: "open"});
        this.shadowRoot.innerHTML = `
      <button part="button" style="
        width: 100%;
        display: flex;
        height: 36px;
        padding: 10px 24px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        border-radius: 7.75rem;
        border: 1px solid #2D6A3B;
        background: #2D6A3B;
        color: #FFF;
        font-family: 'Jost', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        text-transform: capitalize;
        cursor: pointer;
        box-sizing: border-box;
      ">
        ${this.getAttribute("label") || "Checkout"}
      </button>
    `;
    }

    connectedCallback() {
        this.shadowRoot.querySelector("button").addEventListener("click", () => this.checkout());
    }

    async checkout() {
        const discount = this.getAttribute("discount");
        const hasUpgrade = this.getAttribute("has-upgrade");
        
        try {
            if (hasUpgrade && hasUpgrade.trim() !== '' && discount && discount.trim() !== '') {
                window.location.href = `/checkout?discount=${encodeURIComponent(discount)}`;
            } else {
                window.location.href = `/checkout`;
            }
        } catch (err) {
            console.error("Checkout error:", err);
        }
    }
}

if (!customElements.get('custom-checkout-button')) {
    customElements.define("custom-checkout-button", DiscountCheckoutButton);
}

